


























































import { defineComponent, toRefs } from '@vue/composition-api';

import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppFramedRadioGroup from '@berlin-front/common/components/elements/AppFramedRadioGroup';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';
import PaymentMethodInfo from '@clusters/PaymentMethodInfo';
import UserNameFooter from '@clusters/UserNameFooter';

import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { formatNumber } from '@berlin-front/common/utils';

import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { TEXT_ALIGNED } from '@berlin-front/common/components/elements/AppInput/composable';
import { TEXT_COLOR, TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { HEIGHT_TYPE } from '@berlin-front/common/components/elements/AppProgressBar/composable';
import { ALERT_TYPE } from '@berlin-front/common/components/atone-components/AtoneAlert/composable';
import { useContext } from '@berlin-front/common/composables/context';
import { SelectPaymentMethodContext, SPLIT_PATTERN_ONE } from './context';

export default defineComponent({
  name: 'SplitSelectView',
  components: {
    AppButton,
    AppCard,
    AppContainer,
    AppRow,
    AppText,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
    UserNameFooter,
    PaymentMethodInfo,
    AppFramedRadioGroup,
  },

  setup() {
    const { useSelectPaymentMethod } = useContext(SelectPaymentMethodContext);
    const { itemTotalAmount, usablePatterns, selectedPattern, memberName, next } = toRefs(useSelectPaymentMethod());

    return {
      itemTotalAmount,
      usablePatterns,
      selectedPattern,
      memberName,
      next,

      // 定数値。
      HEADER_TYPE,
      TEXT_ALIGNED,
      ALERT_TYPE,
      HEIGHT_TYPE,
      TEXT_SIZE,
      TEXT_COLOR,
      TEXT_WEIGHT,
      SPLIT_PATTERN_ONE,

      formatNumber,
    };
  },
});
